/* eslint-disable import/prefer-default-export */
import { measureStyleType } from '../constants/enums';
/**
 * 取得顯示燒結檢測單的量測規格
 * @param specSettings - array: 所有的量測規格（含啟用＆未啟用）
 * @param measureStyle - number: 該量測規格的 StyleType
 * @param measureConfig - array: 上一次送出的量測規格
 * @param isDiff - boolean: 是否為要取得不一樣的量測規格
 */

export const getSpec = (specSettings, measureStyle, measureConfig = [], isDiff = false) => {
  let currentSpec;

  if (
    isDiff &&
    (measureStyle === measureStyleType.COIL || measureStyle === measureStyleType.STAR)
  ) {
    currentSpec = specSettings
      .filter((spec) =>
        measureConfig.find(
          (config) => spec.styleId === measureStyle && config.measureId.toString() === spec.specId
        )
      )
      .map((item) => item.specRecipe);
  }
  if (isDiff && measureStyle !== measureStyleType.COIL && measureStyle !== measureStyleType.STAR) {
    currentSpec = specSettings
      .filter((spec) =>
        measureConfig.find(
          (config) => spec.styleId === measureStyle && config.specId === spec.specId
        )
      )
      .map((item) => item.specRecipe);
  }
  if (!isDiff) {
    currentSpec = specSettings
      .filter((spec) => spec.styleId === measureStyle && spec.isEnabled)
      .map((item) => item.specRecipe);
  }

  return currentSpec;
};

/**
 * 計算並回傳 specConfig 的上下限等相關欄位的數值版本。
 *
 * @param {Object} specConfig - 規格設定物件
 * @param {string} specConfig.specId - 規格唯一識別碼，例如 "1960"
 * @param {string} specConfig.specItem - 規格項目名稱，例如 "A"
 * @param {string} specConfig.specTarget - 目標值，例如 "16"
 * @param {string} specConfig.specUpper - 上限值，例如 "0.4"
 * @param {string} specConfig.specLower - 下限值，例如 "0.4"
 * @param {string} specConfig.specBias - 偏差值
 * @param {string} specConfig.limitUpper - 規格上限
 * @param {string} specConfig.limitLower - 規格下限
 * @param {string} specConfig.specRecipe - 規格配方
 * @param {number} specConfig.styleId - 規格類型ID，例如 1
 * @param {string} specConfig.styleName - 規格類型名稱，例如 "尺寸"
 * @param {boolean} specConfig.isEnabled - 是否啟用
 * @param {Array} specConfig.measureConfig - 量測設定
 * @param {boolean} specConfig.isActive - 是否為啟用狀態
 * @param {number} specConfig.colStatus - 欄位狀態，例如 2
 * @returns {Object} 回傳帶有數值型上下限等欄位的新 specConfig 物件
 */

export const getCalculatedSpecConfig = (specConfig) => ({
  ...specConfig,
  specUpper: specConfig.specTarget
    ? Number(specConfig.specTarget) + Number(specConfig.specUpper)
    : specConfig.specUpper,
  specLower: specConfig.specTarget
    ? Number(specConfig.specTarget) - Number(specConfig.specLower)
    : specConfig.specLower,
  specTarget: specConfig.specTarget,
  limitUpper: specConfig.specTarget
    ? Number(specConfig.specTarget) + Number(specConfig.limitUpper)
    : specConfig.limitUpper,
  limitLower: specConfig.specTarget
    ? Number(specConfig.specTarget) - Number(specConfig.limitLower)
    : specConfig.limitLower,
});
